const SettingTitleBox = ({
  title
}) => {
  return (
    <div
      className="flex justify-center"
      style={{
        backgroundColor: '#1c2039'
      }}
    >
      <div
        className="py-8 px-10 text-white text-left"
        style={{
          fontSize: '28px',
          width: '1199px'
        }}
      >
        {title}
      </div>
    </div>
  )
}

export default SettingTitleBox;